import {
  actionShowModal,
  actionHideModal,
} from 'react-redux-app/lib/modules/modal/actions';

import { MODAL_DIALOG__WIRE_FILE } from '../../constants/dialogs';


export const actionShowWireFileDialog = imgSrc => dispatch => (
  dispatch(actionShowModal(MODAL_DIALOG__WIRE_FILE, { imgSrc }))
);

export const actionHideWireFileDialog = () => dispatch => (
  dispatch(actionHideModal(MODAL_DIALOG__WIRE_FILE))
);
